// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"383e73cb","161":"105fe6df"}[chunkId] + ".chunk.js";
};